import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { IField, SnackbarService } from '@shared';
import { ProgressBarService, ProjectService } from '../service';
import {
  changeProjectInfoField,
  changeProjectInfoFieldFailure,
  changeProjectInfoFieldSuccess,
  deleteProjectLogoFile,
  deleteProjectLogoFileFailure,
  deleteProjectLogoFileSuccess,
  getProgress,
  getProgressFailure,
  getProgressSuccsess,
  getProjectInfo,
  getProjectInfoFailure,
  getProjectInfoSuccess,
  uploadProjectLogoFile,
  uploadProjectLogoFileFailure,
  uploadProjectLogoFileSuccess,
} from './project.actions';
import { catchError, combineLatest, map, mergeMap, of, switchMap } from 'rxjs';
import { IProjectInfo } from '@shared/model/project';
import { IProjectConfig, IProjectLogo } from '@shared/model/projects';
import { ProjectsService } from '@app/projects/services';

@Injectable()
export class ProjectEffects {
  constructor(
    private _actions$: Actions,
    private _projectService: ProjectService,
    private _projectsService: ProjectsService,
    private _progressBarService: ProgressBarService,
    private _snackbarService: SnackbarService,
  ) { }

  getProjectInfo$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getProjectInfo.type),
      mergeMap(({ id }) =>
        combineLatest([this._projectService.getProjectInfo(id), this._projectsService.getProjectConfig(id)]).pipe(
          map(([projectInfo, projectConfig]: [IProjectInfo, IProjectConfig]) =>
            getProjectInfoSuccess({ project: { id, ...projectInfo }, projectConfig }),
          ),
          catchError((err) => {
            console.log(err);
            this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            return of(getProjectInfoFailure());
          }),
        ),
      ),
    ),
  );

  changeProjectInfoField$ = createEffect(() =>
    this._actions$.pipe(
      ofType(changeProjectInfoField.type),
      mergeMap(({ id, data }: { id: number; data: IField }) =>
        this._projectService.updateProjectField(id, data).pipe(
          map(() => {
            return changeProjectInfoFieldSuccess({ data });
          }),

          catchError((err) => {
            console.log(err);
            this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            return of(changeProjectInfoFieldFailure());
          }),
        ),
      ),
    ),
  );


  loadProgress$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(getProgress.type),
      switchMap(({ id }) =>
        this._progressBarService.joinProject(id).pipe(
          map((progress) => {
            return getProgressSuccsess({ progress });
          }),
          catchError((error) => {
            console.log(error);
            this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            return of(getProgressFailure());
          }),
        ),
      ),
    );
  });

  uploadProjectLogoFile$ = createEffect(() =>
    this._actions$.pipe(
      ofType(uploadProjectLogoFile.type),
      mergeMap(({ id, file, file_type }) =>
        this._projectService.uploadLogoFile(id, file, file_type).pipe(
          map((file: IProjectLogo) => uploadProjectLogoFileSuccess({ file })),
          catchError((error) => {
            console.log(error);
            this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            return of(uploadProjectLogoFileFailure());
          }),
        ),
      ),
    ),
  );

  deleteProjectLogoFile$ = createEffect(() =>
    this._actions$.pipe(
      ofType(deleteProjectLogoFile.type),
      mergeMap(({ id }) =>
        this._projectService.deleteLogoFile(id).pipe(
          map((file: IProjectLogo) => deleteProjectLogoFileSuccess({ id })),
          catchError((error) => {
            console.log(error);
            this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            return of(deleteProjectLogoFileFailure());
          }),
        ),
      ),
    ),
  );
}
